export default __webpack_public_path__ + "static/media/flag-standalone 2.2740e3c6.svg";